import React from "react";
import Box from "@mui/material/Box";
import { Navigate, useNavigate } from "react-router-dom";
import SettingsMenuComponent from "../SettingsMenuComponent";
import { changePassword, security } from "../messages";
import { useSession } from "../../hooks/useSession";
import CommonHeader from "../CommonHeader";

const Security = () => {
  const navigate = useNavigate();
  const { session } = useSession();

  if (session && session?.user?.signup_method !== "email") {
    return <Navigate to="/settings" />;
  }

  const securityMenu = [
    {
      name: changePassword,
      icon: "changePassword",
      action: () => navigate("/settings/security/change-password"),
    },
  ];
  return (
    <>
      <CommonHeader textAfterIcon={security} icon="backArrow" />
      <Box className="options-container">
        <Box className="advance-settings-wrapper">
          <Box className="module-container">
            <SettingsMenuComponent menu={securityMenu} />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Security;
